<work-ui-modal #confirmationModal
               (modalClosedWithNoButton)="declineAction()"
               [hideCloseButton]="modalOptions.hideCloseButton || false"
               [introText]="modalOptions.infoText || ''"
               [modalWidth]="'small'"
               [titleText]="modalOptions.title!"
               modalId="confirmationModal">
  <ng-container modal-body>
    @if (confirmationModal.isOpen && modalOptions.bodyHtml) {
      <div [innerHTML]="modalOptions.bodyHtml"></div>
    }
  </ng-container>
  <ng-container modal-footer>
    @if (confirmationModal.isOpen) {
      @if (modalOptions.buttons && modalOptions.buttons.length > 2) {
        <div class="flex flex-column gap-12 width-100">
          @for (button of modalOptions.buttons; track button) {
            <work-ui-button (click)="doAction(button)"
                            [fullWidth]="true"
                            [text]="button.label"
                            [variant]="button.variant" />
          }
        </div>
      } @else {
        @for (button of modalOptions.buttons; track button) {
          <work-ui-button (click)="doAction(button)"
                          [fullWidth]="true"
                          [text]="button.label"
                          [variant]="button.variant"
                          style="flex: 1" />
        }
      }
    }
  </ng-container>
</work-ui-modal>
